import { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAllowed, useAuthContext } from 'context/AuthContext';
import { AccessRoles } from 'shared/auth';
import { styled } from '@mui/material';
import LoadingPage from 'pages/common/LoadingPage/LoadingPage';

const Wrapper = styled('div')({
  display: 'flex',
  flexGrow: 1,
});

interface ProtectedRouteProps {
  allowedRoles: AccessRoles[];
}

export function ProtectedRoute({
  allowedRoles,
  children,
}: PropsWithChildren<ProtectedRouteProps>) {
  const { userRoles, rolesLoaded } = useAuthContext();
  const location = useLocation();

  if (!rolesLoaded) return <LoadingPage />;

  if (!isAllowed(allowedRoles, userRoles)) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  return <Wrapper>{children}</Wrapper>;
}

export default ProtectedRoute;
